import React, { ReactNode, useMemo } from "react";
import classNames from "classnames";

import CheckBox from "..";

export type CheckBoxItemType = {
  label: string | ReactNode;
  value: string;
  disabled?: boolean;
  checked?: boolean;
};
export type CheckBoxItem = Omit<CheckBoxItemType, "checked"> | string;
export type CheckboxGroupProps = {
  option: CheckBoxItem[];
  onChange?: (value: string[]) => void;
  defaultChecked?: string[] | string;
  padding?: true;
  border?: boolean;
  style?: React.CSSProperties;
  checkboxStyle?: React.CSSProperties;
  align?: "center" | "end";
  direction?: "rtl";
  justify?: "around" | "between";
  color?: string;
  size?: number;
};

const CheckboxGroup: React.FC<CheckboxGroupProps> = props => {
  const {
    option,
    onChange,
    defaultChecked,
    padding,
    border,
    style,
    checkboxStyle,
    ...rest
  } = props;

  const getOpions = useMemo(() => {
    return option.map((item: CheckBoxItemType | string) => {
      let checkedItem =
        typeof defaultChecked === "string" ? [defaultChecked] : defaultChecked;
      if (typeof item === "string") {
        return {
          label: item,
          value: item,
          checked: checkedItem?.includes(item),
        };
      } else {
        if (checkedItem?.includes(item.value)) {
          item.checked = true;
        }
        return item;
      }
    });
  }, [option, defaultChecked]);

  // const [innerOption, setInnerOption] = useState(getOpions);

  // useEffect(() => {
  // setInnerOption(getOpions);
  // }, [defaultChecked, getOpions]);

  const handleChange = (checked, index) => {
    const newoption = [...getOpions];
    newoption[index].checked = checked;
    // setInnerOption(newoption);
    const newValue = newoption.filter(k => k.checked).map(item => item.value);

    onChange?.(newValue);
  };

  const cls = classNames("xh-checkbox-group", { padding }, { border });
  return (
    <div className={cls} style={style}>
      {getOpions.map((item, index) => {
        return (
          <CheckBox
            label={item.label}
            value={item.value}
            disabled={item.disabled}
            checked={item.checked}
            key={index}
            style={checkboxStyle}
            onChange={checked => handleChange(checked, index)}
            {...rest}
          />
        );
      })}
    </div>
  );
};

export default CheckboxGroup;
